import { render, staticRenderFns } from "./addImages.vue?vue&type=template&id=53c810de"
import script from "./addImages.vue?vue&type=script&lang=js"
export * from "./addImages.vue?vue&type=script&lang=js"
import style0 from "./addImages.vue?vue&type=style&index=0&id=53c810de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports